import React, { useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { BUSINESS_ROUTE } from 'data/global';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import api from '../../api';
import useCallbackAsync from 'hooks/useCallbackAsync';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import DisplayRichTextString from 'components/RichTextEditorField/components/DisplayRichTextString';
import { ShareableLinkMainInfo } from 'models/ShareableLink';

import './ShareableLinkTermsAndConditions.styles.scss';

type ShareableLinkTermsAndConditionsProps = {
  className?: string;
  shareableLinkId: string;
  termsAndConditionsContent: string;
  updateAuthInfo: (newMainInfo: ShareableLinkMainInfo) => void;
};

const ShareableLinkTermsAndConditions: React.FC<
  ShareableLinkTermsAndConditionsProps
> = (props) => {
  const {
    className,
    shareableLinkId,
    termsAndConditionsContent,
    updateAuthInfo,
  } = props;

  const [isRejected, setIsRejected] = useState(false);

  const classes = classNames(
    'shareable-link-terms-and-conditions',
    { 'shareable-link-terms-and-conditions--rejected': isRejected },
    className,
  );

  const { t } = useTranslation();

  const [onTermsAndConditionsAgree, isLoading] = useCallbackAsync(async () => {
    const { data } = await api.shareableLinks.acceptTermsAndConditions(
      shareableLinkId,
    );

    updateAuthInfo(data);
  });

  if (isRejected)
    return (
      <ShareableLinkLockScreen
        className={classes}
        title={t('youAreNotAllowedToAccessFiles')}
      >
        <div className="actions">
          <Button variant="outline" onClick={() => setIsRejected(false)}>
            {t('goBackToTC')}
          </Button>
          <Link
            to={BUSINESS_ROUTE}
            className="ncoded-button ncoded-button--solid"
          >
            {t('goToResolve')}
          </Link>
        </div>
      </ShareableLinkLockScreen>
    );

  return (
    <div className={classes}>
      <p>{t('acceptTCBeforeAccessingFiles')}</p>

      <div className="content">
        <p>{t('termsAndConditions')}</p>
        <DisplayRichTextString disableShowMore>
          {termsAndConditionsContent}
        </DisplayRichTextString>
      </div>

      <div className="actions">
        <Button
          variant="link"
          disabled={isLoading}
          onClick={() => setIsRejected(true)}
        >
          {t('dontAgree')}
        </Button>
        <Button disabled={isLoading} onClick={onTermsAndConditionsAgree}>
          {t('iAgree')}
        </Button>
      </div>
    </div>
  );
};

export default ShareableLinkTermsAndConditions;
